import React from 'react'
import {Box, BoxProps, Stack, Text} from '../../vanilla'
import { useBasketStore } from '../../store/hooks/useStore'
import { createRestrictedMessage } from '../algolia/util/utils'
import { Hit } from '../../store/ProductStore'

interface UnavailableProductsOverlayProps extends BoxProps<React.ElementType> {
hit: Hit
}

export const RestrictedProductsOverlay = ({
    hit,
  ...restBoxProps
}: UnavailableProductsOverlayProps) => {

    const {checkIfProductIsRestricted, findRestrictedProductLimit} = useBasketStore()

    const isProductRestricted = hit.productClasses ? checkIfProductIsRestricted(hit.productClasses) : undefined
    const hitMaxOrderQuantity = hit?.maxOrderQuantity
    const restrictedProductLimit = hit.productClasses ? findRestrictedProductLimit(hit.productClasses) : undefined
    const maxQuantityAllowed = hitMaxOrderQuantity != null && restrictedProductLimit != null 
    ? Math.min(hitMaxOrderQuantity, restrictedProductLimit) 
    : hitMaxOrderQuantity ?? restrictedProductLimit

    if (!isProductRestricted || maxQuantityAllowed == null) {
        return null
    }

    return (
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="absolute"
        width='full'
        height='full'
        {...restBoxProps}
        >
            <Stack
                spacing="2px"
                alignItems="center"
                borderRadius="base"
                marginX="16px"
                paddingY="8px"
                paddingX="12px"
                style={{backgroundColor: 'rgba(219, 219, 219, 0.93)'}}
            >
                <Text textAlign="center" variant="text4" lineHeight="shorter">
                    {createRestrictedMessage(maxQuantityAllowed)}
                </Text>
            </Stack>
        </Box>
    )
}